import { render, staticRenderFns } from "./usersList.vue?vue&type=template&id=023b299e"
import script from "./usersList.vue?vue&type=script&lang=js"
export * from "./usersList.vue?vue&type=script&lang=js"
import style0 from "./usersList.vue?vue&type=style&index=0&id=023b299e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports